import { render, staticRenderFns } from "./chargingOrderDetails.vue?vue&type=template&id=bffc8ca4&scoped=true"
import script from "./chargingOrderDetails.vue?vue&type=script&lang=js"
export * from "./chargingOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./chargingOrderDetails.vue?vue&type=style&index=0&id=bffc8ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc8ca4",
  null
  
)

export default component.exports